import React from "react";
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import ReactFileViewer from "../../commonfields/ReactFileViewer";

const FileViewerModal = (props: any) => {
  const { viewFile, setViewFile, documentsData } = props

  return (
    <Modal
      className=" mw-100 w-50 fileViewerModalWrapper messageCenterFileView"
      isOpen={viewFile}
      fade={false}
      toggle={setViewFile}
    >
      <ModalHeader toggle={setViewFile}>
        <Row className="customHeader modal-title">
          <Col>
            <div
              className={`fileHeader`}
            >
              {documentsData?.fileName}
            </div>
          </Col>
        </Row>
        <Row></Row>
      </ModalHeader>
      <ModalBody>
        <div className="TC_fileView">
          {documentsData ? (
            <ReactFileViewer
              fileDocument={documentsData}
            />
          ) : (
            <></>
          )}
        </div>
      </ModalBody>
    </Modal>
  )

}

export default FileViewerModal